import { readStoredJson, writeStoredJson } from "./safeStorage";

// "Use System" on the web follows the computer (Phil 2026-10-16). The app resolves dark mode from ?mode= in the apps
// and from the stored global.darkMode otherwise, a value nothing refreshed, so the web kept whatever was stored last.
// Imported first in index.jsx: it stores the browser's current setting before any module or layout reads it.
const query = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
const appMode = () => new URLSearchParams(window.location.search).get("mode");

export const systemDark = () => !!query && query.matches;

function sync() {
  if (!query || appMode()) return false;
  const g = readStoredJson("global", null) || { darkMode: false, useCustomTheme: false, customTheme: false };
  if (g.useCustomTheme || g.darkMode === query.matches) return false;
  writeStoredJson("global", { ...g, darkMode: query.matches });
  return true;
}
sync();

// While the page is open: the computer flips → apply it (only under Use System, never on a light-only overlay page).
export function watchSystemTheme(apply) {
  if (!query) return;
  const onChange = () => {
    if (window.location.pathname.split("/")[3] === "overlay") return;
    if (sync()) apply(query.matches);
  };
  if (query.addEventListener) query.addEventListener("change", onChange);
  else if (query.addListener) query.addListener(onChange);
}
